import { ADD_PARENT_STYLE, LOAD_PARENT_STYLE } from './../../action-types/bookproperties';

export const STATE_KEY = 'parentStyle';

export const parentStyle = (state = {}, action) => {
  switch (action.type) {
    case ADD_PARENT_STYLE: {
      return action.style;
    }

    case LOAD_PARENT_STYLE: {
      return action.style;
    }

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/redux/reducers/bookproperties/parentStyle.js